import type { WidgetSpan } from '../../../store/dashboardStore';
import { widgetMenuBlocked } from './widget-menu-keys';

/**
 * 시작 틀 셋 — 처음 여는 사람의 빈 카드 아래 · 새 대시보드 창 (2026-09-16 · 대시보드 시안 v2 V5 · V6 · 규칙 D12 · Q-3).
 *
 * ★★★ **위젯 키와 기본 폭만** 적는다. 숫자 · 샘플 데이터 · 사람 이름은 없다 — 틀은 «배치»이지 «내용»이 아니다.
 * ★★ Q-3 결정: 1단계는 **웹 상수**다. 회사가 틀을 고치고 싶다는 요청이 생기면 서버 기본판(DR14)으로 옮긴다.
 * ★ 메뉴가 꺼진 위젯은 담을 때 뺀다(`pickStarterWidgets`) — 켜지지 않는 위젯을 틀이 떠안기면 첫 화면이 「사용 안 함」 카드로 찬다.
 *   어느 위젯이 어느 메뉴에 기대는지는 `widget-menu-keys` 한 곳이 정한다.
 */

export interface StarterWidget {
  key: string;
  span: WidgetSpan;
}

export interface StarterTemplate {
  id: 'my-day' | 'lead' | 'project';
  name: string;
  widgets: readonly StarterWidget[];
}

export const STARTER_TEMPLATES: readonly StarterTemplate[] = [
  {
    id: 'my-day',
    name: '내 하루',
    widgets: [
      { key: 'attendance', span: 8 },
      { key: 'calendar', span: 4 },
      { key: 'schedule', span: 4 },
      { key: 'notices', span: 4 },
      { key: 'today-todo', span: 4 },
    ],
  },
  {
    id: 'lead',
    name: '팀장',
    widgets: [
      { key: 'team-presence', span: 4 },
      { key: 'approval', span: 8 },
      { key: 'week-summary', span: 8 },
      { key: 'room-status', span: 4 },
    ],
  },
  {
    id: 'project',
    name: '프로젝트',
    widgets: [
      { key: 'tasks', span: 4 },
      { key: 'week-timeline', span: 8 },
      { key: 'recent-docs', span: 4 },
      { key: 'chats', span: 8 },
    ],
  },
];

export interface StarterPick {
  widgets: StarterWidget[];
  /** 메뉴가 꺼져 빠진 위젯 수 — 「n개는 메뉴가 꺼져 빠졌습니다」. */
  dropped: number;
}

/** 틀에서 담을 위젯 — 메뉴가 꺼진 것을 뺀다. */
export function pickStarterWidgets(t: StarterTemplate, menuEnabled: (menuKey: string) => boolean): StarterPick {
  const widgets = t.widgets.filter((w) => !widgetMenuBlocked(w.key, menuEnabled));
  return { widgets, dropped: t.widgets.length - widgets.length };
}

export function droppedNote(dropped: number): string | null {
  return dropped > 0 ? `${dropped}개는 메뉴가 꺼져 빠졌습니다` : null;
}

/**
 * 새 대시보드 창을 시작 틀로 채워 여는 값 — 처음 여는 사람의 틀 카드가 넘긴다.
 * ★ 폭은 만든 **뒤에** 틀의 폭으로 맞춘다(`createBoard` 는 모두 1/3 로 놓는다).
 */
export interface CreateBoardPreset {
  templateId?: StarterTemplate['id'];
  name: string;
  widgets: Array<{ key: string; span: WidgetSpan }>;
  /** 「n개는 메뉴가 꺼져 빠졌습니다」. */
  note?: string | null;
}
